import ActionButton from "../ActionButton";
import Footer from "../Footer";
import Header from "../Header";
import React, {useEffect} from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ErrorPage.module.css";
import usePageView from "../../lib/usePageView";
import {Container, Column, Row} from "../grid";
import {useLocation} from "react-router-dom";

const strings = {
    title: "1st Financial Bank USA Unexpected Error",
    header: "Something went wrong",
    body:
        "An error has occurred while processing your request. For your security, this page has been reset. Please try again.",
    startNew: "Try Again",
};

type RouterState = {
    destination?: string;
};

export default function ErrorPage() {
    useEffect(() => {
        document.title = strings.title;
    }, []);

    SetNoIndex();
    usePageView(strings.title);

    const location = useLocation<RouterState>();
    const pathname = location.state?.destination;

    return (
        <>
            <Header />
            <Container className={styles.container}>
                <Row className={styles.titleRow}>
                    <Column>
                        <h1 className={styles.title}>{strings.header}</h1>
                        <div className={styles.body}>{strings.body}</div>
                    </Column>
                </Row>
                {pathname ? (
                    <Row>
                        <Column>
                            <ActionButton
                                label={strings.startNew}
                                linkTo={{
                                    pathname,
                                    search: window.location.search,
                                    hash: "",
                                    state: location.state,
                                }}
                                openInSameTab={true}
                            />
                        </Column>
                    </Row>
                ) : null}
            </Container>
            <Footer />
        </>
    );
}
